import script from "./Messages.vue?vue&type=script&lang=ts&setup=true"
export * from "./Messages.vue?vue&type=script&lang=ts&setup=true"

import "./Messages.vue?vue&type=style&index=0&id=18d8e3a4&lang=css"

const __exports__ = script;

export default __exports__